class Cliente {
  constructor(
    id = "",
    nombre = "",
    apellido = "",
    email = "",
    telefono = "",
    ci = "",
    nit = "",
    fecha_nacimiento = "",
    permisosHutCoins = false,
    razon_social = "",
    direcciones = []
  ) {
    this.id = id;
    this.nombre = nombre;
    this.apellido = apellido;
    this.email = email;
    this.telefono = telefono;
    this.ci = ci;
    this.nit = nit;
    this.fecha_nacimiento = fecha_nacimiento;
    this.permisosHutCoins = permisosHutCoins;
    this.razon_social = razon_social;
    this.direcciones = direcciones;
  }
}

class Direccion {
  constructor(alias = "", indicaciones = "", lat = 0, lng = 0) {
    this.alias = alias;
    this.indicaciones = indicaciones;
    this.lat = lat;
    this.lng = lng;
  }
}

class Sucursal {
  constructor({
    id_publico = "",
    id = "",
    lat = 0,
    lng = 0,
    nombre = "",
    estado = true,
    servicios = [],
    turnos = "[]",
    localizacion = "",
    telefono = "",
    backend = "",
  }) {
    this.id_publico = id_publico;
    this.id = id;
    this.lat = lat;
    this.lng = lng;
    this.nombre = nombre;
    this.estado = estado;

    // Parsear servicios si viene como string
    try {
      if (typeof servicios === "string") {
        // Si el string tiene formato Python ['item1', 'item2'], convertirlo a JSON válido
        let serviciosStr = servicios.trim();
        if (!serviciosStr) {
          this.servicios = [];
        } else {
          if (serviciosStr.startsWith("['") || serviciosStr.startsWith('["')) {
            // Convertir formato Python a JSON
            serviciosStr = serviciosStr.replace(/'/g, '"');
          }
          this.servicios = JSON.parse(serviciosStr);
        }
      } else if (Array.isArray(servicios)) {
        this.servicios = servicios;
      } else {
        this.servicios = [];
      }
    } catch (error) {
      console.error("Error parseando servicios:", error, servicios);
      this.servicios = [];
    }

    try {
      const turnosParsed =
        typeof turnos === "string" ? JSON.parse(turnos) : turnos;

      // Convertir cada turno en instancia de la clase Turno
      this.turnos = turnosParsed.map((turnoData) => new Turno(turnoData));
    } catch (error) {
      console.error("Error parseando turnos:", error);
      this.turnos = [];
    }

    this.localizacion = localizacion;
    this.telefono = telefono;
    this.backend = backend;
  }

  tieneServicio(nombreServicio) {
    if (!this.servicios || !Array.isArray(this.servicios)) {
      return false;
    }
    return this.servicios.some(
      (servicio) => servicio.toLowerCase() === nombreServicio.toLowerCase()
    );
  }

  tieneEnvioADomicilio() {
    return this.tieneServicio("Envio a domicilio");
  }

  tieneRecogerEnLocal() {
    return this.tieneServicio("Recoger en local");
  }
}

class Turno {
  constructor({ dias = [], horaInicial = "", horaFinal = "" }) {
    this.dias = dias;
    this.horaInicial = horaInicial;
    this.horaFinal = horaFinal;
  }

  // Método útil: verificar si el turno aplica para un día específico
  aplicaParaDia(numeroDia) {
    return this.dias.includes(numeroDia);
  }

  // Método útil: obtener nombres de días
  obtenerNombresDias() {
    const nombresDias = [
      "",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];
    return this.dias.map((dia) => nombresDias[dia]);
  }
}

class Coleccion {
  constructor({
    id = "",
    nombre = "",
    imagen = window.assets.imagen_aux,
    productos = [],
    metafields = [],
    tipo = "",
  }) {
    this.id = id;
    this.nombre = nombre;
    this.imagen = imagen;
    this.productos = productos;
    this.metafields = metafields;
    this.tipo = tipo;
  }
}

class Producto {
  constructor({
    idshopify = "",
    idtrabajo = "",
    url = "",
    handle = "",
    nombre = "",
    descripcion = "",
    estado = false,
    precio = 0,
    precio_comparacion = 0,
    obj_num = "",
    imagen = window.assets.imagen_aux,
    stockTotal = 0,
    sucursales = [],
    metafield = "",
    tipoProducto = "",
    dia = "",
    colecciones = [],
    tags = [],
  }) {
    this.idshopify = idshopify;
    this.idtrabajo = idtrabajo;
    this.url = url;
    this.handle = handle;
    this.nombre = nombre;
    this.descripcion = descripcion;
    this.estado = estado;
    this.precio = parseInt(precio);
    this.precio_comparacion = parseInt(precio_comparacion);
    this.obj_num = obj_num;
    this.imagen = imagen;
    this.stockTotal = stockTotal;
    this.sucursales = sucursales;
    this.metafield = metafield;
    this.tipoProducto = tipoProducto;
    this.dia = dia;
    this.colecciones = colecciones;
    this.tags = tags;
  }
}

class ProductoCarrito {
  constructor({
    item_base = null,
    items_principales = {},
    colecciones_trabajo = [],
  }) {
    this.item_base = item_base;
    this.items_principales = items_principales;
    this.colecciones_trabajo = colecciones_trabajo;
  }
}

class ItemCarrito {
  constructor({
    idshopify = "",
    idtrabajo = "",
    titulo = "",
    nombre = "",
    precio = 0,
    precio_comparacion = 0,
    cantidad = 0,
    imagen = window.assets.imagen_aux,
    sucursales = [],
    stockTotal = 0,
    obj_num = "",
    descuento = 0,
  }) {
    this.idshopify = idshopify ?? "";
    this.idtrabajo = idtrabajo ?? "";
    this.titulo = titulo ?? "";
    this.nombre = nombre ?? "";
    this.precio = precio ?? 0;
    this.precio_comparacion = precio_comparacion ?? 0;
    this.cantidad = cantidad ?? 0;
    this.imagen = imagen ?? window.assets.imagen_aux;
    this.sucursales = sucursales ?? [];
    this.stockTotal = stockTotal ?? 0;
    this.obj_num = obj_num ?? "";
    this.descuento = descuento ?? 0;
  }
}

class ItemRecontruccion {
  constructor({ idshopify = "", idtrabajo = "", cantidad = 0 }) {
    this.idshopify = idshopify;
    this.idtrabajo = idtrabajo;
    this.cantidad = cantidad;
  }
}

class MaquetacionProducto {
  constructor({
    producto = null,
    estructura = null,
    subProductoSeleccionado = null,
    colecciones = [],
  }) {
    this.producto = producto;
    this.estructura = estructura;
    this.subProductoSeleccionado = subProductoSeleccionado;
    this.colecciones = colecciones;
  }
}

class MaquetacionOrden {
  constructor({
    // INFORMACIÓN BÁSICA
    id = "",
    nro = "",
    total = 0,
    estado = "",
    tiempo_creacion = "",
    total_items = 0,
    nota = "",
    // LINE ITEMS
    line_items = [],
    // CUSTOM ATTRIBUTES
    email = "",
    telefono = "",
    ci = "",
    nit = "",
    razon_social = "",
    metodo_pago = "",
    metodo_entrega = "",
    alias = "",
    indicaciones = "",
    local_designado = "",
    cc_coordenadas = "",
    cc_google_maps = "",
    detalle_reconstruccion = "",
  }) {
    this.id = id;
    this.nro = nro;
    this.total = total;
    this.estado = estado;
    this.tiempo_creacion = tiempo_creacion;
    this.total_items = total_items;
    this.nota = nota;
    this.line_items = line_items;
    this.email = email;
    this.telefono = telefono;
    this.ci = ci;
    this.nit = nit;
    this.razon_social = razon_social;
    this.metodo_pago = metodo_pago;
    this.metodo_entrega = metodo_entrega;
    this.alias = alias;
    this.indicaciones = indicaciones;
    this.local_designado = local_designado;
    this.cc_coordenadas = cc_coordenadas;
    this.cc_google_maps = cc_google_maps;
    this.detalle_reconstruccion = detalle_reconstruccion;
  }
}

class LineItemOfOrden {
  constructor({ nombre = "", precio = 0, cantidad = 0, imagen = "", properties = [] }) {
    this.nombre = nombre;
    this.precio = precio;
    this.cantidad = cantidad;
    this.imagen = imagen ?? "";
    this.properties = properties;
  }
}

class SeleccionCondimentos {
  static objetoASeccionesCondimentos(objeto) {
    // Si no hay datos, devolver array vacío
    if (!objeto) return [];

    // Acepta array u objeto plano
    const seccionesFuente = Array.isArray(objeto) ? objeto : Object.values(objeto);

    // Mapear a SeccionCondimentos[]
    return seccionesFuente.map((sec) =>
      new SeccionCondimentos({
        key: sec.key || "",
        titulo: sec.titulo || sec.title || "",
        tipo: sec.tipo || sec.type || "",
        min:
          typeof sec.min === "number" ? sec.min : sec?.restriccion?.min ?? 0,
        max:
          typeof sec.max === "number" ? sec.max : sec?.restriccion?.max ?? 0,
        productos: (Array.isArray(sec?.productos) ? sec.productos : []).map(
          (p) =>
            new ProductoCondimento({
              id: p.id || p.idshopify || p.extCode || "",
              titulo: p.titulo || p.title || p.nombre || "",
              urlImage: p.urlImage || p.imagen || "",
              urlImage2: p.urlImage2 || p.imagen2 || "",
              precio: p.precio != null ? Number(p.precio) : 0,
              precio_comparacion:
                p.precio_comparacion != null
                  ? Number(p.precio_comparacion)
                  : 0,
              estado: p.estado ?? true,
              sucursales: Array.isArray(p.sucursales) ? p.sucursales : [],
              criterios_ver: (p.criterios_ver || p.showCriteria || []).map(
                (c) =>
                  new CriterioVer({
                    seccionKey: c.seccionKey || c.sectionKey || "",
                    optionId: c.opcionId || c.optionId || "",
                    precio: c.precio != null ? Number(c.precio) : 0,
                    precio_comparacion:
                      c.precio_comparacion != null
                        ? Number(c.precio_comparacion)
                        : 0,
                    id: c.id || "",
                  })
              ),
            })
        ),
      })
    );
  }

  constructor({ secciones = [] }) {
    // Un Map tiene <string, string> -> clave (titulo del condimento) : valor (key seccion)
    this.opcionesSeleccionadas = new Map();
    this.seccionesConstruccion = [];
    this.secciones = secciones;
  }

  copiarSeccionesParaContruccion(secciones) {
    return secciones.map(seccion => {
      // Copiar productos manteniendo los objetos ProductoCondimento
      const productosCopia = (seccion.productos || []).map(producto => {
        // Copiar criterios_ver manteniendo los objetos CriterioVer
        const criteriosCopia = (producto.criterios_ver || []).map(criterio =>
          new CriterioVer({
            seccionKey: criterio.seccionKey,
            optionId: criterio.optionId,
            precio: criterio.precio,
            precio_comparacion: criterio.precio_comparacion,
            id: criterio.id,
            estado: criterio.estado
          })
        );

        return new ProductoCondimento({
          id: producto.id,
          titulo: producto.titulo,
          urlImage: producto.urlImage,
          precio: producto.precio,
          precio_comparacion: producto.precio_comparacion,
          estado: producto.estado,
          sucursales: [...(producto.sucursales || [])],
          criterios_ver: criteriosCopia
        });
      });

      // Retornar nueva sección con productos copiados
      return {
        key: seccion.key,
        titulo: seccion.titulo,
        tipo: seccion.tipo,
        min: seccion.min,
        max: seccion.max,
        productos: productosCopia
      };
    });
  }

  estructurarContruccion(sizeSeleccionado) {
    var seccionesConstruccion = this.copiarSeccionesParaContruccion(this.secciones);
    if (sizeSeleccionado != null) {

      seccionesConstruccion = seccionesConstruccion.map((seccion, index) => {

        if (seccion.key == "tamano" || seccion.tipo == "subcarrito") {
          return seccion;
        }

        seccion.productos = (seccion.productos || [])
          .filter(producto => producto != null && producto.criterios_ver != null)
          .map(producto => {

            const criterio_seleccionado = producto.criterios_ver.find(
              criterio => criterio.optionId == sizeSeleccionado.id
            ) || null;

            if (criterio_seleccionado == null) {
              return new ProductoCondimento({
                ...producto,
                estado: false
              });
            }


            return new ProductoCondimento({
              id: criterio_seleccionado.id || producto.id,
              estado: criterio_seleccionado.estado ?? producto.estado ?? true,
              titulo: producto.titulo,
              urlImage: producto.urlImage,
              precio: criterio_seleccionado.precio != null ? criterio_seleccionado.precio : producto.precio,
              precio_comparacion: criterio_seleccionado.precio_comparacion != null ? criterio_seleccionado.precio_comparacion : producto.precio_comparacion,
              sucursales: producto.sucursales || [],
              criterios_ver: producto.criterios_ver || [],
            });
          });

        return seccion;
      });
    } else {
      console.log("No hay tamano seleccionado, usando secciones sin procesar");
    }

    this.seccionesConstruccion = seccionesConstruccion;

    return seccionesConstruccion;
  }

  /**
   * 
   * @param {SeccionCondimentos} seccion 
   * @param {ProductoCondimento} condimento 
   * @param {ProductoCondimento} sizeSeleccionado 
   * @returns {string} "seleccionado", "desactivado" o ""
   * - "seleccionado": El condimento esta seleccionado
   * - "desactivado": El condimento esta desactivado
   * - "": El condimento no esta seleccionado
   */
  estadoCondimentoConstruccion(seccion, condimento, sizeSeleccionado) {
    // 1. Verificar si la sección está en existe en las (this.seccionesConstruccion)
    const seccionConstruida = this.seccionesConstruccion
      .find(s => s.key === seccion.key);

    // 2. Verificar si el condimento existe en la sección construida
    const condimentoConstruccion = seccionConstruida?.productos
      .find(p => p.id === condimento.id || p.titulo === condimento.titulo);

    // 3. Verificar si el condimento esta disponible (estado)
    if (!condimentoConstruccion || condimentoConstruccion.estado === false) return "desactivado";
    // 4. Verificar por el tema sucursales
    if (!this.condimentoDisponibleEnSucursal(condimento)) return "desactivado";

    // 5. Verificar si el condimento ya esta seleccionado
    const llaveCondimento = this._generarKeyCondimento(condimento, seccion.key);
    const seccionGuardada = this.opcionesSeleccionadas.get(llaveCondimento);
    const yaSeleccionado = seccionGuardada !== undefined;

    // 5.5 SI YA ESTÁ SELECCIONADO, retornar "seleccionado" inmediatamente
    if (yaSeleccionado) return "seleccionado";

    // 6. VOLVER A LA LÓGICA ORIGINAL: Si min=0, no auto-seleccionar
    if (seccion.min == 0) return "";

    // 7. Para secciones obligatorias, verificar si hay espacio
    const cantidadSeleccionados = [...this.opcionesSeleccionadas.values()]
      .filter(valor => valor === seccion.key).length;
    const maximo = Number.isFinite(seccion.max) && seccion.max > 0 ? seccion.max : Infinity;

    if (cantidadSeleccionados >= maximo) return "";

    // EXTRA
    if (
      sizeSeleccionado != null &&
      this.opcionesSeleccionadas.get(`${seccion.key}-${sizeSeleccionado.id}-${sizeSeleccionado.titulo}`) == null &&
      seccion.key === "tamano"
    ) {
      if (condimento.id == sizeSeleccionado.id && condimento.titulo == sizeSeleccionado.titulo) {
        this.opcionesSeleccionadas.set(llaveCondimento, seccion.key);
        return "seleccionado";
      } else {
        return "";
      }
    }

    // 8. Verificar si el condimento ya esta seleccionado
    if (yaSeleccionado) return "seleccionado";

    // 9. Auto-seleccionar si está activo y hay espacio
    if (condimentoConstruccion.estado === true) {
      this.opcionesSeleccionadas.set(llaveCondimento, seccion.key);
      return "seleccionado";
    }

    return "";
  }

  /**
   * 
   * @param {SeccionCondimentos} seccion 
   * @returns {boolean} TRUE si cumple las condiciones, FALSE si no.
   * - TRUE: Cumple el min requerido y todavia no llegas al maximoo
   * - TRUE: Puedes agregar mas condimentos 
   * - FALSE: No has llegado al minimo todavia
   * - FALSE: O ya llegaste al maximo
   * - FALSE: si tenemos -1 o mas de lo max igual FALSE
   */
  cumpleCondicionesSeccion(seccion) {
    const cantidadSeleccionados = [...this.opcionesSeleccionadas.values()]
      .filter(valor => valor === seccion.key).length;
    const minimo = seccion.min || 0;
    const maximo = Number.isFinite(seccion.max) && seccion.max > 0 ? seccion.max : Infinity;
    return cantidadSeleccionados >= minimo && cantidadSeleccionados < maximo;
  }

  condimentoDisponibleEnSucursal(condimento) {
    // 1. Verificar si existe una sucursal seleccionada
    const sucursal =
      window.sucursal &&
        typeof window.sucursal === "object" &&
        Object.keys(window.sucursal).length > 0
        ? window.sucursal
        : null;

    // 2. Verificar si existe una sucursal seleccionada
    if (!sucursal) return true;
    // 3. Verificar si la sucursal esta activa
    if (sucursal.estado === false) return false;
    // 4. Verificar si el condimento esta disponible en la sucursal
    return condimento.sucursales.includes(sucursal.id_publico);
  }

  // Genera la key unica para un condimento (formato : "id-titulo")
  _generarKeyCondimento(condimento, seccionKey) {
    return `${seccionKey}-${condimento.id}-${condimento.titulo}`;
  }

  /**
   * Obtiene todos los condimentos seleccionados de una sección específica
   * @returns {Array} Array de [key, seccionKey] para la sección solicitada
   */
  obtenerCondimentosSeccion(seccionKey) {
    return Array.from(this.opcionesSeleccionadas.entries())
      .filter(([key, value]) => value === seccionKey);
  }

  /**
   * Busca el primer condimento seleccionado en una sección
   * @returns {string|null} Key del primer condimento o null
   */
  buscarPrimerCondimentoSeccion(seccionKey) {
    const [primerKey] = this.obtenerCondimentosSeccion(seccionKey)[0] || [];
    return primerKey || null;
  }

  /**
   * Obtiene el siguiente condimento disponible en la lista de productos
   * @returns {Object|null} ProductoCondimento siguiente o null
   */
  obtenerSiguienteCondimento(seccion, tituloActual) {
    const productos = seccion.productos;
    if (!productos || productos.length === 0) return null;

    const indiceActual = productos.findIndex(p => p.titulo === tituloActual);
    return productos[(indiceActual + 1) % productos.length];
  }

  /**
 * Intenta deseleccionar un condimento verificando restricciones min/max
 * @returns {Object} { permitido: boolean, motivo: string }
 */
  intentarDeseleccionar(condimento, seccionKey) {
    const keyCondimento = this._generarKeyCondimento(condimento, seccionKey);
    const seccion = this.seccionesConstruccion.find(s => s.key === seccionKey);

    // Eliminar temporalmente para verificar si cumple el mínimo
    this.opcionesSeleccionadas.delete(keyCondimento);

    const cumpleMinimo = this.cumpleCondicionesSeccion(seccion);

    if (!cumpleMinimo) {
      // Revertir: volver a agregar
      this.opcionesSeleccionadas.set(keyCondimento, seccionKey);
      return {
        permitido: false,
        motivo: 'No cumple con el mínimo requerido',
        accion: 'revertir'
      };
    }

    return {
      permitido: true,
      motivo: 'Deselección permitida',
      accion: 'deseleccionar'
    };
  }

  /**
   * Intenta seleccionar un condimento verificando restricciones min/max
   * Si excede el máximo, indica qué condimento reemplazar
   * @returns {Object} { permitido: boolean, accion: string, condimentoAReemplazar: string|null }
   */
  intentarSeleccionar(condimento, seccionKey) {
    const keyCondimento = this._generarKeyCondimento(condimento, seccionKey);
    const seccion = this.seccionesConstruccion.find(s => s.key === seccionKey);

    // Obtener condimentos actuales ANTES de agregar el nuevo
    const condimentosActuales = this.obtenerCondimentosSeccion(seccionKey);

    // Agregar el nuevo condimento
    this.opcionesSeleccionadas.set(keyCondimento, seccionKey);

    // Verificar si cumple el máximo
    const cumpleMaximo = this.cumpleCondicionesSeccion(seccion);

    if (!cumpleMaximo) {
      // Excedió el máximo: necesita reemplazar
      const [keyAReemplazar] = condimentosActuales[0] || [];

      if (keyAReemplazar) {
        // Eliminar el anterior del Map
        this.opcionesSeleccionadas.delete(keyAReemplazar);

        return {
          permitido: true,
          accion: 'reemplazar',
          condimentoAReemplazar: keyAReemplazar
        };
      }
    }

    return {
      permitido: true,
      accion: 'seleccionar',
      condimentoAReemplazar: null
    };
  }

  /**
   * Maneja la selección de un nuevo tamano
   * Retorna información sobre el tamano anterior y el nuevo
   * @returns {Object} { tamanoAnterior: string|null, nuevoTamano: Object }
   */
  cambiarTamano(nuevoTamano, seccionKey) {
    // Buscar y eliminar tamaño anterior
    const tamanoAnteriorKey = this.buscarPrimerCondimentoSeccion(seccionKey);
    if (tamanoAnteriorKey) {
      this.opcionesSeleccionadas.delete(tamanoAnteriorKey);
    }

    // Guardar los títulos de condimentos seleccionados ANTES de reestructurar
    const condimentosSeleccionadosPorSeccion = new Map();

    this.seccionesConstruccion.forEach(seccion => {
      if (seccion.key === "tamano" || seccion.tipo === "subcarrito") return;

      const titulosSeleccionados = [];

      // Buscar todos los condimentos seleccionados de esta sección
      this.opcionesSeleccionadas.forEach((value, key) => {
        if (value === seccion.key) {
          // Extraer el título de la key (formato: seccionKey-id-titulo)
          const sinPrefijo = key.substring(value.length + 1);
          const primerGuion = sinPrefijo.indexOf('-');
          const titulo = sinPrefijo.substring(primerGuion + 1);
          titulosSeleccionados.push(titulo);
        }
      });

      if (titulosSeleccionados.length > 0) {
        condimentosSeleccionadosPorSeccion.set(seccion.key, titulosSeleccionados);
      }
    });

    // Limpiar TODAS las selecciones (excepto tamaño que ya fue eliminado)
    this.opcionesSeleccionadas.clear();

    // Agregar nuevo tamaño al Map
    const keyNuevoTamano = this._generarKeyCondimento(nuevoTamano, seccionKey);
    this.opcionesSeleccionadas.set(keyNuevoTamano, seccionKey);

    // Reestructurar construcción con el nuevo tamaño
    this.estructurarContruccion(nuevoTamano);

    // Re-seleccionar condimentos usando sus títulos y los NUEVOS IDs
    condimentosSeleccionadosPorSeccion.forEach((titulos, seccionKey) => {
      const seccion = this.seccionesConstruccion.find(s => s.key === seccionKey);
      if (!seccion) return;

      titulos.forEach(titulo => {
        // Buscar el condimento en la sección reconstruida (con el nuevo ID)
        const condimento = seccion.productos?.find(p => p.titulo === titulo);
        if (!condimento) return;

        // Si el condimento está disponible, re-seleccionarlo
        if (condimento && condimento.estado === true) {
          const key = this._generarKeyCondimento(condimento, seccionKey);
          this.opcionesSeleccionadas.set(key, seccionKey);
        } else {
          // Buscar reemplazo si no cumple el mínimo
          const seleccionadosActuales = [...this.opcionesSeleccionadas.values()]
            .filter(v => v === seccionKey).length;

          if (seleccionadosActuales < seccion.min) {
            // Buscar el primer condimento disponible en la sección
            const reemplazo = seccion.productos?.find(p =>
              p.estado === true && this.condimentoDisponibleEnSucursal(p)
            );

            if (reemplazo) {
              const keyReemplazo = this._generarKeyCondimento(reemplazo, seccionKey);
              this.opcionesSeleccionadas.set(keyReemplazo, seccionKey);
            }
          }
        }
      });
    });

    return {
      tamanoAnterior: tamanoAnteriorKey,
      nuevoTamano: nuevoTamano
    };
  }

  /**
   * Procesa un condimento después de cambiar el tamano
   * SOLO calcula qué hacer, NO modifica el Map
   * @returns {Object} { accion: string, condimentoSiguiente: Object|null, estadoCalculado: string }
   */
  procesarCondimentoCambioDeTamano(condimento, seccion, estaSeleccionadoEnHTML, sizeSeleccionado) {
    const estadoCalculado = this.estadoCondimentoConstruccion(
      seccion,
      condimento,
      sizeSeleccionado
    );

    // Si estaba seleccionado pero ahora está desactivado -> REEMPLAZAR
    if (estaSeleccionadoEnHTML && estadoCalculado === "desactivado") {
      const keyCondimento = this._generarKeyCondimento(condimento, seccion.key);

      // Eliminar del Map
      this.opcionesSeleccionadas.delete(keyCondimento);

      // Buscar siguiente condimento disponible
      const condimentoSiguiente = this.obtenerSiguienteCondimento(seccion, condimento.titulo);

      if (condimentoSiguiente) {
        const keySiguiente = this._generarKeyCondimento(condimentoSiguiente, seccion.key);
        this.opcionesSeleccionadas.set(keySiguiente, seccion.key);
      }

      return {
        accion: 'reemplazar',
        condimentoSiguiente: condimentoSiguiente,
        estadoCalculado: estadoCalculado
      };
    }

    // Verificar sincronización del Map
    const keyCondimento = this._generarKeyCondimento(condimento, seccion.key);
    const estaEnMap = this.opcionesSeleccionadas.has(keyCondimento);

    if (estadoCalculado === "seleccionado" && !estaEnMap) {
      // Debería estar seleccionado pero NO está en el Map
      this.opcionesSeleccionadas.set(keyCondimento, seccion.key);
      return { accion: 'sincronizar_agregar', estadoCalculado: estadoCalculado };
    } else if (estadoCalculado === "" && estaEnMap) {
      // NO debería estar seleccionado pero SÍ está en el Map
      this.opcionesSeleccionadas.delete(keyCondimento);
      return { accion: 'sincronizar_eliminar', estadoCalculado: estadoCalculado };
    }

    return {
      accion: 'actualizar',
      estadoCalculado: estadoCalculado
    };
  }
}

class SeccionCondimentos {
  constructor(data = {}) {
    this.key = data.key || "";
    this.titulo = data.titulo || "";
    this.tipo = data.tipo || "";
    this.min = data.min || 0;
    this.max = data.max || 0;
    this.productos = data.productos || [];
  }
}

class ProductoCondimento {
  constructor(data = {}) {
    this.id = data.id || "";
    this.titulo = data.titulo || "";
    this.urlImage = data.urlImage || "";
    this.urlImage2 = data.urlImage2 || "";
    this.precio = data.precio || 0;
    this.precio_comparacion = data.precio_comparacion || 0;
    this.estado = data.estado || false;
    this.sucursales = data.sucursales || [];
    this.criterios_ver = data.criterios_ver || [];
  }
}

class CriterioVer {
  constructor(data = {}) {
    this.seccionKey = data.seccionKey || "";
    this.optionId = data.optionId || "";
    this.precio = data.precio || 0;
    this.precio_comparacion = data.precio_comparacion || 0;
    this.id = data.id || "";
  }
}